import ImagesUrl from "#constants/images.js";
import React from "react";

const SeedDetailComponent = ({ SeedDetailData, parentIndex }) => {
  // Safely access the second item or handle undefined

  return (
    <div className="custom_accordion_item">
      <button
        className="custom_accordion d-flex w-100 justify-content-between align-items-center border-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#collapseCrop_2${parentIndex}`}
        aria-expanded="false"
        aria-controls={`collapseCrop_2${parentIndex}`}
      >
        <p className="m-0 fertility_text">Seed</p>
        <span className="drop_icon">
          <img className="drop_icon" src={ImagesUrl.dopeIcon} alt="drop-icon" />
        </span>
      </button>
      <div
        className="custom_collapse_body collapse"
        id={`collapseCrop_2${parentIndex}`}
      >
        <div className="common-collapse_blk">
          <div className="row gy-4">
            <div className="d-flex justify-content-between px-4 py-1">
              <span>Variety</span>
              <span>{SeedDetailData?.variety || "N/A"}</span>
            </div>
            <div className="d-flex justify-content-between px-4 py-1">
              <span>Rate</span>
              <span>{SeedDetailData?.rate || "N/A"}</span>
            </div>
            <div className="d-flex justify-content-between px-4 py-1">
              <span>Unit</span>
              <span>{SeedDetailData?.unit || "N/A"}</span>
            </div>
            <div className="d-flex justify-content-between px-4 py-1">
              <span>Quantity</span>
              <span>{SeedDetailData?.quantity || "N/A"}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeedDetailComponent;
